import { setUser } from 'lib/reporter';

/**
 * Set users for web reporters
 */
export const loginSuccessHandler = (options: { userUUID: string }): void => {
  setUser(options.userUUID);
  return;
};
